// Canonical URLs for the Code and Infrastructure security pages. The sidebar highlights a
// menu item when the URL starts with its path, so detail pages live under their list's
// path. The legacy /remediation/assets and /remediation/vulnerabilities URLs redirect here
// (AppContent.tsx).

export type SecurityDomain = 'code' | 'infrastructure';

export const ASSETS_PATH = '/security/infrastructure/assets';

export const assetPath = (id: string | number) => `${ASSETS_PATH}/${id}`;

export const findingsPath = (domain: SecurityDomain = 'infrastructure') =>
  `/security/${domain}/findings`;

export const findingPath = (
  id: string | number,
  domain: SecurityDomain = 'infrastructure'
) => `${findingsPath(domain)}/${id}`;

export const FINDING_CREATE_PATH = `${findingsPath()}/create`;

// A finding's domain follows its asset's (backend modules/r_asset/domain.py): a repository
// is Code, everything else Infrastructure.
export const findingDomain = (asset?: { type?: string | null } | null): SecurityDomain =>
  asset?.type === 'repository' ? 'code' : 'infrastructure';

// The sidebar section the URL is in, if any.
export const domainOfPath = (
  pathname: string = window.location.pathname
): SecurityDomain | undefined =>
  pathname.match(/^\/security\/(code|infrastructure)\//)?.[1] as SecurityDomain | undefined;

// The domain the current list page is scoped to, sent as `security_domain` on list and stats
// queries. Asset and finding detail pages sit under a domain's path only for the menu
// highlight; they show the record whatever its domain, as they did under /remediation/.
export const securityDomainFromPath = (
  pathname: string = window.location.pathname
): SecurityDomain | undefined => {
  if (/^\/security\/[^/]+\/(assets|findings)\/[^/]+/.test(pathname)) return undefined;
  return domainOfPath(pathname);
};
